import React from 'react'
import './index.css'
import FlexColumn from 'components/FlexColumn'
import logUtil from 'utils/log'
import H3 from 'components/H3'
import Flex from 'components/Flex'
import Image from 'components/Image'
import ButtonTextPrimary from 'components/ButtonTextPrimary'
import updateCurrentToastAction from 'modules/toast/redux/actions/update-current'
import getMessageErrorUtil from 'modules/error/utils/get-message'
import useDispatch from 'hooks/use-dispatch'
import P from 'components/P'
import PreviousButton from 'components/PreviousButton'
import NextButton from 'components/NextButton'
import getUrlProductUtil from 'modules/product/utils/get-url'
import Link from 'components/Link'
import HoverUnderlined from 'components/HoverUnderlined'
import getHighQualityImageProductUtil from 'modules/product/utils/get-high-quality-image'
import ItemsYouBothLovedContentLikedSuperLiked from 'pages/Squad/containers/Friends/CurrentFriendSampleSummary/Content/ItemsYouBothLoved/Content/LikedSuperLiked'
import { ITEM_ADDED_TO_CART } from 'modules/cart/constants'
import registerSwiperUtil from 'utils/swiper/register'

import addProductAndVariantIdToUrlProductUtil from 'modules/product/utils/add-product-and-variant-id-to-url'
import updateCurrentProductIdAction from 'modules/product/redux/actions/update-current'
import updateCurrentVariantIdAction from 'modules/variant/redux/actions/update-current'
import openQuickShopSidebarProductAction from 'modules/product/redux/actions/open-quick-shop-product-sidebar'

import loadFromUrlProductAction from 'modules/product/redux/actions/load-from-url'
import { PRODUCTS_KEY } from 'modules/product/redux/constants'
import { PRODUCT_OUT_OF_STOCK } from 'modules/product/constants'

import isArchivedProductVariantUtil from 'modules/product-variant/utils/is-archived/index.js'
import addItemCartAction from 'modules/cart/redux/actions/add-item'

const ADD_FULL_SIZE_TO_CART = 'Add Full Size to Cart'
const TITLE_SQUAD_MATCHES = 'Squad matches:'
const TITLE_ITEMS_YOU_BOTH_LOVED = 'items you both loved'
const OUT_OF_STOCK = 'Out of stock'

export default function ItemsYouBothLovedContent (props) {
  const dispatch = useDispatch()
  const debugProps = {
    props
  }
  logUtil('ItemsYouBothLoved').debug('debugProps=', debugProps)
  const swiperElRef = React.useRef()
  const [activeItemIndex, setActiveItemIndex] = React.useState(0)
  const [isArchived, setIsArchived] = React.useState(false)

  /**
   * @type import('modules/squad/types').SquadSummaryData.items_you_both_loved
   */
  const itemsYouBothLoved = props.itemsYouBothLoved
  const isLast = activeItemIndex === itemsYouBothLoved.length - 1

  /**
   * @type import('modules/squad/types').ItemsYouBothLovedInfo
   */
  const activeItem = itemsYouBothLoved[activeItemIndex]

  const isArchivedProduct = isArchivedProductVariantUtil(activeItem?.product)

  const url = getUrlProductUtil(activeItem?.product?.handle, activeItem?.product?.variant_id)

  const handleClickItem = (event, sampleProduct) => {
    event.preventDefault()

    dispatch(updateCurrentProductIdAction(sampleProduct.product_id))
    dispatch(updateCurrentVariantIdAction(sampleProduct.variant_id))

    addProductAndVariantIdToUrlProductUtil({
      productId: sampleProduct.product_id,
      variantId: sampleProduct.variant_id
    })

    dispatch(openQuickShopSidebarProductAction())
  }

  const checkIfProductIsArchived = async () => {
    const { resData } = await dispatch(
      loadFromUrlProductAction({
        key: PRODUCTS_KEY.PRODUCTS_FROM_URL,
        isFullSize: false,
        query: {
          product_ids: [activeItem?.product?.product_id],
          variant_ids: [activeItem?.product?.variant_id]
        }
      })
    )

    setIsArchived(resData?.total_product_count === 0)
  }

  React.useEffect(() => {
    checkIfProductIsArchived()
  }, [activeItem])

  React.useEffect(() => {
    registerSwiperUtil()
    const handleChange = event => {
      logUtil('ItemsYouBothLoved#handleChange').debug('event=', event)
      let activeIndex = event.detail?.[0]?.activeIndex
      if (isNaN(activeIndex)) {
        activeIndex = 1
      }
      if (activeIndex == null) {
        return
      }
      setActiveItemIndex(activeIndex)
    }
    swiperElRef.current?.addEventListener('slidechange', handleChange)
    return () => {
      swiperElRef.current?.removeEventListener('slidechange', handleChange)
    }
  }, [])

  const handlePressPrevious = () => {
    swiperElRef.current?.swiper?.slideTo?.(activeItemIndex - 1)
  }
  const handlePressNext = () => {
    swiperElRef.current?.swiper?.slideTo?.(activeItemIndex + 1)
  }
  // TODO handle adding multiple samples to cart
  const handleClickAddToCart = async () => {
    const variantId = activeItem?.product?.fullsize_variant_id
    logUtil('ItemsYouBothLoved#handleClickAddToCart').debug('[start]')
    try {
      if (isArchived) {
        dispatch(
          updateCurrentToastAction(PRODUCT_OUT_OF_STOCK)
        )
        return
      }

      await dispatch(addItemCartAction({ variantId }))
      dispatch(updateCurrentToastAction(ITEM_ADDED_TO_CART))
    } catch (error) {
      const errorMessage = getMessageErrorUtil(error)
      logUtil('MostPopularSuperLikedSample#handleClickAddToCart').debug(`errorMessage=${errorMessage}`)
      dispatch(
        updateCurrentToastAction(errorMessage)
      )
    }
  }

  return (
    <FlexColumn
      className='squad-items-you-both-loved-content'
    >
      <H3>{TITLE_SQUAD_MATCHES}</H3>
      <H3>{TITLE_ITEMS_YOU_BOTH_LOVED}</H3>
      <Flex
        className='squad-items-you-both-loved-content-items'
      >
        <swiper-container
          slides-per-view='1'
          ref={swiperElRef}
          style={{
            zIndex: 0,
            SwiperPaginationColor: 'white'
          }}
          pagination={false}
        >
          {
            itemsYouBothLoved.map((itemsYouBothItem, index) => {
              const image = itemsYouBothItem?.product?.image_url

              return (
                <swiper-slide key={`${itemsYouBothItem?.product?.variant_id}-${index}`}>
                  <FlexColumn
                    className='squad-items-you-both-loved-content-item'
                  >
                    <Flex
                      className='squad-items-you-both-loved-content-item-image'
                    >
                      <Link
                        onClick={(e) => {
                          handleClickItem(e, itemsYouBothItem?.product)
                        }}
                        href={url}
                      >
                        <Image
                          src={getHighQualityImageProductUtil(image)}
                          alt={itemsYouBothItem?.product?.title}
                          shouldLazyLoad={!!index}
                        />
                      </Link>
                    </Flex>
                  </FlexColumn>
                </swiper-slide>
              )
            })
          }
        </swiper-container>
      </Flex>
      <ItemsYouBothLovedContentLikedSuperLiked
        activeItem={activeItem}
      />
      <P className='squad-items-you-both-loved-content-liked-title'>
        <Link
          onClick={(e) => {
            e.preventDefault()

            if (isArchivedProduct) {
              return
            }

            handleClickItem(e, activeItem?.product)
          }}
          href={url}
        >
          <HoverUnderlined>{activeItem?.product?.title}</HoverUnderlined>
        </Link>
      </P>
      <Flex className='squad-items-you-both-loved-content-actions'>
        <Flex
          className='squad-items-you-both-loved-content-button'
        >
          <ButtonTextPrimary onClick={handleClickAddToCart}>{isArchivedProduct ? OUT_OF_STOCK : ADD_FULL_SIZE_TO_CART}</ButtonTextPrimary>
        </Flex>
        <Flex
          className='squad-items-you-both-loved-content-previous-next'
        >
          <PreviousButton
            onClick={handlePressPrevious}
            disabled={!activeItemIndex}
          />
          <NextButton
            onClick={handlePressNext}
            disabled={isLast}
          />
        </Flex>
      </Flex>
    </FlexColumn>
  )
}
